// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Referral_referralSection__m07Ek {
  text-align: left;
  margin-bottom: 24px;
}

.Referral_referralCard__MShSm {
  background: #2a2a2a;
  padding: 24px;
  margin-bottom: 24px;
}

.Referral_referralInfo__j4L3E {
  margin-bottom: 20px;
  color: #666;
}

.Referral_referralLinkBox__Kmv\\+J {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.Referral_referralInput__TLjEU {
  flex: 1 1;
  padding: 12px 16px;
  background: #1a1a1a;
  border: 1px solid #333;
  color: #ffffff;
  font-family: monospace;
  font-size: 14px;
}

.Referral_referralInput__TLjEU:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.Referral_copyButton__SPuQO {
  padding: 0 24px;
  background: #ffffff;
  color: #000000;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.Referral_copyButton__SPuQO:hover:not(:disabled) {
  opacity: 0.9;
}

.Referral_copyButton__SPuQO:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.Referral_copyButton__SPuQO.Referral_copied__Ultfs {
  background: #ABFF00;
  color: #000000;
}

.Referral_warning__z2Gmq {
  color: #ff4444;
  font-size: 14px;
  margin-top: 12px;
  text-align: center;
}

.Referral_referralStats__u0LYC {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
}

.Referral_referralStat__PIbeN {
  background: #2a2a2a;
  padding: 24px;
  text-align: center;
}

.Referral_referralStat__PIbeN h3 {
  color: #666;
  margin-bottom: 12px;
  font-size: 14px;
}

.Referral_referralStat__PIbeN p {
  font-size: 24px;
  font-weight: 600;
}

@media (max-width: 768px) {
  .Referral_referralStats__u0LYC {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dappPages/DashboardPage/Referral/Referral.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".referralSection {\n  text-align: left;\n  margin-bottom: 24px;\n}\n\n.referralCard {\n  background: #2a2a2a;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.referralInfo {\n  margin-bottom: 20px;\n  color: #666;\n}\n\n.referralLinkBox {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.referralInput {\n  flex: 1;\n  padding: 12px 16px;\n  background: #1a1a1a;\n  border: 1px solid #333;\n  color: #ffffff;\n  font-family: monospace;\n  font-size: 14px;\n}\n\n.referralInput:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.copyButton {\n  padding: 0 24px;\n  background: #ffffff;\n  color: #000000;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.copyButton:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.copyButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.copyButton.copied {\n  background: #ABFF00;\n  color: #000000;\n}\n\n.warning {\n  color: #ff4444;\n  font-size: 14px;\n  margin-top: 12px;\n  text-align: center;\n}\n\n.referralStats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 24px;\n}\n\n.referralStat {\n  background: #2a2a2a;\n  padding: 24px;\n  text-align: center;\n}\n\n.referralStat h3 {\n  color: #666;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.referralStat p {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .referralStats {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"referralSection": `Referral_referralSection__m07Ek`,
	"referralCard": `Referral_referralCard__MShSm`,
	"referralInfo": `Referral_referralInfo__j4L3E`,
	"referralLinkBox": `Referral_referralLinkBox__Kmv+J`,
	"referralInput": `Referral_referralInput__TLjEU`,
	"copyButton": `Referral_copyButton__SPuQO`,
	"copied": `Referral_copied__Ultfs`,
	"warning": `Referral_warning__z2Gmq`,
	"referralStats": `Referral_referralStats__u0LYC`,
	"referralStat": `Referral_referralStat__PIbeN`
};
export default ___CSS_LOADER_EXPORT___;
